define(['vendor/jquery.touchSwipe.min.js', 'vendor/jquery.slideandswipe.js', 'vendor/autocomplete_rails.js'], function(touchSwipe, slideAndSwipe, autocomplete) {
  var headerNavWithSubItem = function(el) {
    var activeClass = 'is-active';
    var $navBox = el;

    var handleClick = function(evn) {
      evn.preventDefault();
      var $item = $(this);

      if (!$item.hasClass(activeClass)) {
        $navBox.find('.' + activeClass).each(function() {
          var $item = $(this);
          $item.removeClass(activeClass);
          $item.hasClass('nav-links-list-subitem') && $item.css('height', 0);
        });

        $item.addClass(activeClass);
        var subItem = $($item.attr('href'));
        subItem.css('height', subItem.children().outerHeight() + 'px');
        $(subItem).addClass(activeClass);
      }
    };

    if (el) {
      el.find('.nav-links-list-item > .nav-links-list-item__title').each(function() {
        var $item = $(this);
        var item_href = $item.attr('href');
        var subDoc;

        if (item_href.indexOf('#') != -1 && $(item_href).length) {
          $item.on('click', handleClick);
          if ($item.hasClass(activeClass)) {
            var subItem = $($item.attr('href'));
            subItem.css('height', subItem.children().outerHeight() + 'px');
          }
        }
      });
    }
  };

  var Header = function() {};

  var init = function() {
    $('.nav-links-box').slideAndSwipe();
    headerNavWithSubItem($('.nav-links-box--mobile'));

    var globalSearch = $('.global-search');

    globalSearch.focus(function() {
      $(this)
        .parent()
        .addClass('active');
    });

    globalSearch.blur(function() {
      if ($(this).val() == '') {
        $(this)
          .parent()
          .removeClass('active');
      }
    });

    if (globalSearch.length) {
      globalSearch
        .autocomplete({
          minLength: 2,
          appendTo: '.search-box',
          delay: 500,
          source: function(request, response) {
            $.ajax({
              url: $('.global-search').data('action-url'),
              dataType: 'json',
              data: {
                q: {
                  by_candidate_cont: request.term
                }
              },
              messages: {
                noResults: ''
              },
              success: function(data) {
                response(data);
              }
            });
          },
          search: function(event, ui) {
            $('.spinningCircle').show();
          },
          response: function(event, ui) {
            $('.spinningCircle').hide();
          }
        })
        .focus(function() {
          $(this).autocomplete('search', this.value);
        })
        .autocomplete('instance')._renderItem = function(ul, item) {
        var results = $('<div>');
        $.each(item.applicants, function(index, value) {
          createListItem(value).appendTo(results);
        });
        $.each(item.interests, function(index, value) {
          createListItem($.extend(value.user, { application_id: value.id })).appendTo(results);
        });
        $.each(item.partners_applicants, function(index, value) {
          createListItem($.extend(value.user, { application_id: value.id, source_id: 3 })).appendTo(results);
        });
        if (!item.applicants.length && !item.interests.length && !item.partners_applicants.length) {
          results.append('Not found');
        }
        return results.appendTo(ul);
      };
    }
  };

  var createListItem = function(user) {
    var globalSearch = $('.global-search');
    var link = globalSearch.data('url');
    if (user.step_id) {
      link += 'jobs/' + user.job_id + '/applicants/' + user.id;
    } else {
      link += 'talent-pool/' + user.application_id;
      if (user.source_id) link += '?source_id=' + user.source_id;
    }
    var item = $('<a>', { href: link });

    var failover = globalSearch.data('failover');
    var img = $('<img/>', { src: user.full_photo_url || failover }).appendTo(item);
    img.error(function() {
      if (this.src != failover) {
        this.src = failover;
      }
    });

    var name = $('<div>').appendTo(item);
    $('<span/>', { class: 'name' })
      .html(user.first_name + ' ' + user.last_name)
      .appendTo(name);
    var job_name = user.job ? user.job.position_title : 'Talent pool';
    $('<span/>', { class: 'position' })
      .html(job_name)
      .appendTo(name);

    return item;
  };

  return init;
});
